import * as CONSTS from 'redux/constants';
import { submitCardPayment } from 'redux/actions/checkout';
import { DigitalWalletProvider, RECURRENCE_TYPES } from 'consts';

export const updateApplePaySupportedDevice = ({ supported }) => ({
  type: CONSTS.UPDATE_APPLE_PAY_SUPPORTED_DEVICE,
  payload: { supported }
});

export const payWithApple = ({
  token,
  paymentMethodType,
  digitalWalletData,
  isRecurrenceTypeRecurring
}) => {
  const recurrenceTypeRecurringDataToSend = {
    savePaymentMethod: true,
    fields: {
      recurrence_type: RECURRENCE_TYPES.recurring
    }
  };

  return async dispatch => {
    return dispatch(
      submitCardPayment({
        token,
        paymentMethodType,
        savePaymentMethod: false,
        digitalWallet: {
          data: digitalWalletData,
          provider: DigitalWalletProvider.APPLE_PAY
        },
        ...(isRecurrenceTypeRecurring ? recurrenceTypeRecurringDataToSend : {})
      })
    );
  };
};
